import React from "react";

const BoltSnt = () => {
  return (
    <section>
    
      <iframe src="https://app.powerbi.com/view?r=eyJrIjoiNmMzYjMzZmItMDgwNi00ZmUxLTgyYjAtNzJlMDI3ODgzZDNjIiwidCI6ImYyMzQ4MWYzLTI2ZGItNGZjOC1hNzliLTFiZTk2ZWZjMzg4YyIsImMiOjR9&pageName=ReportSectionda28b1d634ab51b6b500" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default BoltSnt;
